<template>
  <div id="10_risk_acceptance_container" :class="cardSizeClass">
    <div class="vx-row no-gutter items-center justify-center p-6">
      <vx-card class="py-3 px-3 mb-5">
        <div class="vx-row">
          <div class="vx-col w-full">
            <p class="text-2xl card-sub-title">
              Constancia electrónica de riesgos
            </p>
            <p>
              Completa la siguiente constancia para estar seguros de que conoces las implicaciones de invertir en
              RedGirasol.
            </p>
          </div>
        </div>
      </vx-card>
      <vx-card class="py-3 px-3">
        <div slot="no-body" class="">
          <div class="vx-col sm:w-full">
            <div class="login-tabs-container">
              <div class="vx-row m-0">
                <div class="vx-col w-full p-0" style="min-height: 200px">
                  <!-- RISKS-DIV -->
                  <div class="px-6 pt-5 pb-5">
                    <!-- CONTENT -->
                    <div class="main-form mt-5">
                      <div class="vx-row mt-4">
                        <div :class="colClassFull">
                          <div v-for="(risk, index) in risksData" :key="index">
                            <span v-show="currentRiskQuestion == index">
                              <vs-row vs-w="12" vs-justify="center" vs-align="center">
                                <vs-col vs-justify="center" vs-align="center" vs-lg="12">
                                  <div class="flex flex-wrap justify-start">
                                    <feather-icon v-if="riskRadioAnswers[risk.value] == null" icon="CircleIcon" svgClasses="w-5 h-5 mr-1 text-success" />
                                    <feather-icon v-else-if="riskRadioAnswers[risk.value] != risk.correctValue"
                                      icon="XCircleIcon" svgClasses="w-5 h-5 mr-1 text-danger" />
                                    <feather-icon v-else icon="CheckCircleIcon" svgClasses="w-5 h-5 mr-1 text-success" />
                                    <label class="bold">{{ risk.title }} ({{ currentRiskQuestion+1 }}/7)</label>
                                  </div>
                                  <br>
                                  <label>{{ risk.subtitle }}</label>
                                  <br>
                                  <span v-if="risk.subtitle2">
                                    <br>
                                    <label>{{ risk.subtitle2 }}</label>
                                    <br>
                                  </span>
                                  <br>
                                  <label class="bold">{{ risk.question }}</label>
                                  <div class="flex justify-start ml-2 mt-base">
                                    <vs-row vs-w="12">
                                      <vs-col vs-lg="6">
                                        <div class="flex justify-start">
                                          {{ }}
                                          <template v-if="risk.correctValue == 0">
                                            <rg-radio class="w-full" :groupName="'question_' + index" label="No"
                                              :value="0" v-model="riskRadioAnswers[risk.value]" />
                                            <rg-radio class="w-full ml-5" :groupName="'question_' + index" label="Sí"
                                              :value="1" v-model="riskRadioAnswers[risk.value]" />
                                          </template>
                                          <template v-else>
                                            <rg-radio class="w-full" :groupName="'question_' + index" label="Sí"
                                              :value="1" v-model="riskRadioAnswers[risk.value]" />
                                            <rg-radio class="w-full ml-5" :groupName="'question_' + index" label="No"
                                              :value="0" v-model="riskRadioAnswers[risk.value]" />
                                          </template>
                                        </div>
                                      </vs-col>
                                    </vs-row>
                                  </div>
                                </vs-col>
                              </vs-row>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- END CONTENT DIV -->
                  </div>
                  <!-- END RISKS-DIV -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="flex justify-center mt-4">
          <vs-button v-if="currentRiskQuestion > 0" color="dark" class="mr-5" @click="showPrevStep">Regresar</vs-button>
          <vs-button id="10_risk_acceptance_confirm_btn" @click="showNextStep" :disabled="!canContinueNextQuestion">Continuar</vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import inputHelper from "@mixins/inputHelper";
import defaultParametersHelper from '@mixins/defaultParametersHelper';
import formatHelper from '@mixins/formatHelper';
export default {
  mixins: [inputHelper, defaultParametersHelper, formatHelper],
  props: ["onboardingStepData"],
  data() {
    return {
      colClassFull: "vx-col w-full",
      colClass: "vx-col md:w-1/2 sm:w-full w-full mb-5",
      currentRiskQuestion: 0,
      contractRiskType: 15,
      currentLocation: null,
      locationOptions: {
        enableHighAccuracy: true,
        timeout: Infinity,
        maximumAge: 0
      },
      risksAnswersCorrect: false,
      riskRadioAnswers: [],
      maxEffectiveInvestmentWithdrawalPerInvestorPerDayParam:0
    };
  },
  async mounted() {
    if ('geolocation' in navigator) {
      await navigator.geolocation.getCurrentPosition(this.onSuccessLocation, this.onErrorLocation, this.locationOptions);
    }
    this.maxEffectiveInvestmentWithdrawalPerInvestorPerDayParam = await this.getPublicParam('max_effective_investment_withdrawal_per_investor_per_day');
  },
  computed: {
    currentOnboardingStep() {
      return this.onboardingStepData.onboarding_step;
    },
    cardSizeClass() {
      return "vx-col sm:w-5/6 xl:w-4/5 xxl:w-2/3 m-0";
    },
    canContinueNextQuestion() {
      let currentQuestion = this.risksData[this.currentRiskQuestion];
      let currentAnswer = this.riskRadioAnswers[this.currentRiskQuestion];
      return (currentAnswer && currentAnswer == currentQuestion.correctValue)? true: false;
    },
    maxEffectiveInvestmentWithdrawalPerInvestorPerDay(){
      return this.mxnFormat(this.maxEffectiveInvestmentWithdrawalPerInvestorPerDayParam);
    },
    risksData(){
      return [
        {
          title: 'Sin asesoría',
          subtitle: 'RedGirasol no ofrece asesoría de inversión.',
          subtitle2: null,
          question: '¿Esperas que RedGirasol te asesore y tome decisiones por ti?',
          value: '0',
          correctValue: '0'
        },
        { 
          title: 'Riesgo de pérdida', 
          subtitle: 'Al invertir en RedGirasol, tendrás la propiedad de los contratos de crédito en los que participes. Esto significa que recibirás directamente los intereses pagados por los acreditados y que tendrás exposición directa al comportamiento de pago de los mismos.', 
          subtitle2: 'Para mitigar este riesgo, construimos un portafolio con cientos de créditos, en el cual participarás desde tu primer depósito. Esto minimiza el impacto en el rendimiento de tu inversión por posibles retrasos y quebrantos.',
          question: '¿Comprendes que serás dueño de un portafolio con cientos de créditos y que tendrás exposición directa? Es decir, recibirás directamente el pago de intereses, cuando sea que los acreditados los realicen, así como tener afectaciones directas por retrasos y quebrantos.', 
          value: '1', 
          correctValue: '1' 
        },
        { 
          title: 'Riesgo de liquidez', 
          subtitle: 'Con el objetivo de generar interés compuesto diario, todos los días se reinviertirán la totalidad de los pagos que recibas. Todos los días, podrás solicitar un retiro de hasta '+this.maxEffectiveInvestmentWithdrawalPerInvestorPerDay+', que estará sujeta a la liquidez disponible por el resto de los Inversionistas de la plataforma. ', 
          subtitle2: 'Nota: El monto máximo de liquidez por día, podrá modificarse en el tiempo sin previo aviso.',
          question: '¿Comprendes que todos los días se reinvertirán los pagos recibidos y que la liquidez de tu capital estará sujeta a la liquidez disponible por el resto de los Inversionistas de la plataforma?', 
          value: '2', 
          correctValue: '1' 
        },
        { 
          title: 'Riesgo de información', 
          subtitle: 'Para fines de transparencia y trazabilidad, podrás consultar diversa información de los créditos que conforman el portafolio. Sin embargo, para proteger la identidad de los Solicitante, no divulgaremos información sensible de los mismos.', 
          subtitle2: null,
          question: '¿Comprendes que tendrás acceso limitado a la información de los Solicitantes?', 
          value: '3', 
          correctValue: '1' 
        },
        { 
          title: 'Riesgo de rendimiento', 
          subtitle: 'El rendimiento que recibas provendrá directamente de los pagos realizados por los acreditados. RedGirasol no ofrece rendimiento fijo. El portafolio de créditos en el que participarás cuenta con una gran diversificación, lo cual disminuye la volatilidad, generando rendimientos estables y predecibles.', 
          subtitle2: null,
          question: '¿Comprendes que el rendimiento es variable y depende completamente del comportamiento de pago de los acreditados que conforman el portafolio de créditos?', 
          value: '4', 
          correctValue: '1' 
        },
        { 
          title: 'Sin aprobación', 
          subtitle: 'Los créditos financiados en RedGirasol son evaluados y calificados por una metodología propia (supervisada por la CNBV). A pesar de que la CNBV supervisa dicha metodología, no revisa ni aprueba los créditos de la plataforma.', 
          subtitle2: null,
          question: '¿Comprendes que los créditos son autorizados por RedGirasol y no por la CNBV o alguna otra autoridad financiera?', 
          value: '5', 
          correctValue: '1' 
        },
        { 
          title: 'Inversión',
          subtitle: 'Ni el Gobierno Federal ni las entidades de la administración pública paraestatal podrán responsabilizarse o garantizar los recursos de los clientes que sean utilizados en las operaciones que celebren con las ITF o frente a otros, así como tampoco asumir alguna responsabilidad por las obligaciones contraídas por las ITF o por algún cliente frente a otro, en virtud de las operaciones que celebren.', 
          subtitle2: null,
          question: '¿Has leído este formulario y comprendes los riesgos de llevar a cabo estas inversiones?', 
          value: '6', 
          correctValue: '1' 
        }
      ]
    }
  },
  methods: {
    async showNextStep() {
      if (this.currentRiskQuestion < 6) {
        this.currentRiskQuestion += 1;
      } else {
        if (this.correctRisksAnswers() == 7) {
          this.saveDataForm();
        } else {
          this.errorNotif(
            "Aviso",
            "Deberás responder correctamente todas las anteriores para poder avanzar."
          );
        }
      }
    },
    async showPrevStep() {
      if (this.currentRiskQuestion <= 6) {
        this.currentRiskQuestion -= 1;
      }
    },
    async saveDataForm() {
      this.showLoading(true, "Guardando información...");
      try {
        let geolocation = null;
        if (this.currentLocation) {
          geolocation = "Lat: " + this.currentLocation.latitude + ", Long: " + this.currentLocation.longitude;
        }
        let payload = {
          // onboarding_step: this.currentOnboardingStep,
          contractType: this.contractRiskType,
          geolocation: geolocation
        };
        await axios.post(
          "/api/v2/investor/" + this.InvestorId + "/saveOnboardingStep",
          payload
        );
        this.showLoading(false);
        this.$emit("updated", 1);
      } catch (e) {
        this.showLoading(false);
        this.showError(e);
      }
    },
    showError(e) {
      this.warn(e);
      let err = "Ha ocurrido un error con la operación, intente más tarde";
      if (e.response && e.response.data && e.response.data.error) {
        err = e.response.data.error;
      }
      this.errorMssg = err;
    },
    async onSuccessLocation(pos) {
      this.currentLocation = pos.coords;
    },
    onErrorLocation(err) {
      // console.log(err);
    },
    correctRisksAnswers() {
      let allAnswers = 0;
      this.riskRadioAnswers.forEach((value, index) => {
        let risk = this.risksData[index];
        if (risk.correctValue == value) {
          allAnswers += 1;
        }
      });
      return allAnswers;
    }
  },
};
</script>
<style scoped>
.vx-card.border-primary {
  border-style: solid;
  border-width: 1px;
}
</style>
